import { Directive, TemplateRef, inject, input } from '@angular/core';

/**
 * Marks an `<ng-template>` as the content of one note tab:
 * `<ng-template notePanel="attachments"> ... </ng-template>`.
 * The shell renders it lazily (first visit) and keeps it alive afterwards.
 */
@Directive({ selector: 'ng-template[notePanel]', standalone: true })
export class NotePanelDirective {
  readonly id = input.required<string>({ alias: 'notePanel' });
  readonly template = inject<TemplateRef<unknown>>(TemplateRef);
}
